import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import {
  Box,
  Stack,
  Divider,
  TextField,
  Typography,
  Button,
} from '@mui/material';
import { FormikProvider, FieldArray } from 'formik';
import FormLabel from '../../common/form/FormLabel';
import EmpModalContainer from '../../../containers/common/form/modal/EmpModalContainer';
import NumberFormatText from '../../common/form/NumberFormatText';
import RoInternalCostsForm from './RoInternalCostsForm';

const SalesProfitForm = ({ formik, chance, orderInfo }) => {
  //chance.totalProfit:매출이익
  //chance.totalSales:매출액

  // roAdjProfitAmt(최종영업이익) = roProfitAmt(매출이익) - roInternalAmt(내부거래비용) - roCostAmt(예상영업비용)

  //전체갑(totalSales)에서 매출이익은 몇 %일까?
  const handleChangeRoCost = () => {
    const totalSales = chance?.totalSales; //매출액
    const numberValue = Number(formik?.values?.roCostAmt);
    const percent = Math.round((numberValue / totalSales) * 100);

    formik.setFieldValue('roCostAmtPercent', percent);
    getTotalMargin();
  };

  const handleChangeRoCostPercent = () => {
    const totalSales = chance?.totalSales; //매출액
    const numberPercent = Number(formik?.values?.roCostAmtPercent);
    const numberValue = Math.round(totalSales * (numberPercent / 100));

    formik.setFieldValue('roCostAmt', numberValue);
    getTotalMargin();
  };

  // 최종 매출이익
  const getTotalMargin = () => {
    const totalSales = Number(chance?.totalSales);
    const roProfitAmt = Number(formik?.values?.roProfitAmt);
    const totalInternalAmt = _.sumBy(
      formik?.values?.roInternalCosts,
      'roInternalAmt',
    );

    const roCostAmt = Number(formik?.values?.roCostAmt);
    const roAdjProfitAmt = roProfitAmt - roCostAmt - totalInternalAmt;

    const percent = Math.round((roAdjProfitAmt / totalSales) * 100);

    formik.setFieldValue('roAdjProfitAmt', roAdjProfitAmt);
    formik.setFieldValue('roAdjProfitAmtPercent', percent);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Stack spacing={1}>
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          sx={{
            py: 1,
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          <Box sx={{ width: '180px' }} textAlign="center">
            <FormLabel sx={{ px: 1 }}>매출이익</FormLabel>
          </Box>
          <Box>
            <TextField
              size="small"
              required
              variant="outlined"
              fullWidth
              id="roProfitAmt"
              name="roProfitAmt"
              value={formik.values.roProfitAmt}
              error={
                formik.touched.roProfitAmt && Boolean(formik.errors.roProfitAmt)
              }
              helperText={
                formik.touched.roProfitAmt && formik.errors.roProfitAmt
              }
              InputProps={{
                inputComponent: NumberFormatText,
              }}
              disabled
            />
          </Box>
          <Box>
            <TextField
              size="small"
              required
              variant="outlined"
              fullWidth
              id="roProfitAmtPercent"
              name="roProfitAmtPercent"
              value={formik.values.roProfitAmtPercent}
              error={
                formik.touched.roProfitAmtPercent &&
                Boolean(formik.errors.roProfitAmtPercent)
              }
              helperText={
                formik.touched.roProfitAmtPercent &&
                formik.errors.roProfitAmtPercent
              }
              InputProps={{
                inputComponent: NumberFormatText,
              }}
              disabled
              sx={{ width: '80PX' }}
            />
          </Box>
          <Box>%</Box>
        </Stack>
        <FormikProvider value={formik}>
          <FieldArray
            name="roInternalCosts"
            render={(arrayHelpers) => (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    py: 1,
                    borderBottom: (theme) =>
                      `1px solid ${theme.palette.divider}`,
                  }}
                >
                  <Box sx={{ width: 180 }} textAlign="center">
                    <FormLabel sx={{ px: 1 }}>내부거래비용</FormLabel>
                  </Box>
                  <Button
                    type="button"
                    color="secondary"
                    variant="outlined"
                    onClick={() =>
                      arrayHelpers.push({
                        roPartnerUsrNm: '',
                        roPartnerUsr: '',
                        roInternalAmt: 0,
                        roInternalAmtPercent: 0,
                      })
                    }
                  >
                    추가
                  </Button>
                </Box>
                <Box sx={{ py: 1 }}>
                  {formik.values?.roInternalCosts &&
                    formik.values?.roInternalCosts.map((roCost, index) => {
                      return (
                        <RoInternalCostsForm
                          key={index}
                          cost={roCost}
                          index={index}
                          touched={formik.touched}
                          errors={formik.errors}
                          handleChange={formik.handleChange}
                          handleBlur={formik.handleBlur}
                          handleRemove={() => arrayHelpers.remove(index)}
                          totalSales={chance?.totalSales}
                          handleRoAdj={getTotalMargin}
                        />
                      );
                    })}
                </Box>
              </Box>
            )}
          ></FieldArray>
        </FormikProvider>
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          sx={{
            py: 1,
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          <Box sx={{ width: '180px' }} textAlign="center">
            <FormLabel sx={{ px: 1 }}>영업비용</FormLabel>
          </Box>
          <Box>
            <TextField
              size="small"
              required
              variant="outlined"
              fullWidth
              id="roCostAmt"
              name="roCostAmt"
              value={formik.values.roCostAmt}
              onChange={(e) => {
                formik.setFieldValue('roCostAmt', e.target.value);
              }}
              onBlur={handleChangeRoCost}
              error={
                formik.touched.roCostAmt && Boolean(formik.errors.roCostAmt)
              }
              helperText={formik.touched.roCostAmt && formik.errors.roCostAmt}
              InputProps={{
                inputComponent: NumberFormatText,
              }}
            />
          </Box>
          <Box>
            <TextField
              size="small"
              required
              variant="outlined"
              fullWidth
              id="roCostAmtPercent"
              name="roCostAmtPercent"
              value={formik.values.roCostAmtPercent}
              onChange={(e) => {
                formik.setFieldValue('roCostAmtPercent', e.target.value);
              }}
              onBlur={handleChangeRoCostPercent}
              error={
                formik.touched.roCostAmtPercent &&
                Boolean(formik.errors.roCostAmtPercent)
              }
              helperText={
                formik.touched.roCostAmtPercent &&
                formik.errors.roCostAmtPercent
              }
              InputProps={{
                inputComponent: NumberFormatText,
              }}
              sx={{ width: '80PX' }}
            />
          </Box>
          <Box>%</Box>
        </Stack>
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          sx={{
            py: 1,
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          <Box sx={{ width: '180px' }} textAlign="center">
            <FormLabel sx={{ px: 1 }}>최종매출이익</FormLabel>
          </Box>
          <Box>
            <TextField
              size="small"
              required
              variant="outlined"
              fullWidth
              id="roAdjProfitAmt"
              name="roAdjProfitAmt"
              value={formik.values.roAdjProfitAmt}
              error={
                formik.touched.roAdjProfitAmt &&
                Boolean(formik.errors.roAdjProfitAmt)
              }
              helperText={
                formik.touched.roAdjProfitAmt && formik.errors.roAdjProfitAmt
              }
              InputProps={{
                inputComponent: NumberFormatText,
              }}
              disabled
            />
          </Box>
          <Box>
            <TextField
              size="small"
              required
              variant="outlined"
              fullWidth
              id="roAdjProfitAmtPercent"
              name="roAdjProfitAmtPercent"
              value={formik.values.roAdjProfitAmtPercent}
              error={
                formik.touched.roAdjProfitAmtPercent &&
                Boolean(formik.errors.roAdjProfitAmtPercent)
              }
              helperText={
                formik.touched.roAdjProfitAmtPercent &&
                formik.errors.roAdjProfitAmtPercent
              }
              InputProps={{
                inputComponent: NumberFormatText,
              }}
              disabled
              sx={{ width: '80PX' }}
            />
          </Box>
          <Box>%</Box>
        </Stack>
      </Stack>
    </Box>
  );
};

export default SalesProfitForm;
